import client from './api-client';

export const serviceGetGestores = async (query) => {
    try {
        const response = await client.get(`proveedores-rol?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceGetSolicitudes = async(query) => {
    try {
        
        const response = await client.get(`informe-profesional/solicitudes?q=${query}`);      
        
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch(error){
        throw error;
    }
}
export const serviceGetRequisitos = async (query) => {
    try {
        const response = await client.get(`requisitos-gestion?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}
export const serviceGestionaSolicitudInforme = async (body) => {
    try {
        const response = await client.post('informe-profesional/gestionar', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}